var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"translation-dom-elements"},[_vm._l((_vm.elements),function(el,key){return [(el.class==='BR')?_c('span',{key:key},[_c('br')]):_c('span',{key:key,class:el.class},[_vm._v(_vm._s(el.text))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }